import { useRef, useState } from "react";
import { Dropdown, Overlay } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

export default function ActionMenu({ index, actions = [] }) {
  const toggleRef = useRef(null);
  const [show, setShow] = useState(false);

  return (
    <>
      <Dropdown.Toggle
        ref={toggleRef}
        as="button"
        style={{ background: "transparent", border: "none" }}
        className="text-dark"
        id={`dropdown-basic-${index}`}
        onClick={() => setShow((prev) => !prev)}
      >
        <FontAwesomeIcon icon={faEllipsisV} />
      </Dropdown.Toggle>

      <Overlay
        show={show}
        target={toggleRef.current}
        placement="bottom-end"
        containerPadding={20}
        rootClose
        onHide={() => setShow(false)}
      >
        {({ placement, arrowProps, show: _show, popper, ...props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "0.25rem",
              boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.15)",
              zIndex: 1050,
            }}
            className="dropdown-menu show"
          >
            {actions.map((action, i) => (
              <button
                key={i}
                className={`dropdown-item d-flex py-1 ${
                  action.color || ""
                }`}
                onClick={() => {
                  setShow(false);
                  action.onClick();
                }}
              >
                 {action.icon && <span className="me-2 text-center">{action.icon}</span>}
                {action.label}
              </button>
            ))}
          </div>
        )}
      </Overlay>
    </>
  );
}
